export default __webpack_public_path__ + "static/media/betterlegal_logotype-TM.9fd5d3f1.svg";